/**
 * Пресеты цвета для записей справочников (культуры, типы операций).
 *
 * Почему сетка пресетов, а не сырой RGB-пикер (решение founder 08.08):
 * системный `input type=color` вываливает поля R/G/B и HSB — агроному это
 * незачем, а получившиеся цвета на карте соседствуют плохо (два почти
 * одинаковых зелёных на смежных полях читаются как один). Готовая сетка,
 * как в macOS/Office, решает задачу «выбрал за секунду и не промахнулся».
 *
 * Список СВОЙ, а не производный от `cropColors` (правка design-lead 08.08):
 * та палитра — 11 пастельных пар `{bg, border}`, привязанных к ИМЕНАМ культур
 * для чипов и бейджей. Для свотчей она не годится ни составом, ни насыщенностью.
 *
 * Требования design-lead, зашитые в состав:
 *   · порядок ПО ТОНУ — красные → оранжевые → жёлтые → зелёные → бирюзовые →
 *     синие → фиолетовые → нейтральные: глаз идёт по радуге, а не по hex;
 *   · не больше ДВУХ оттенков в секторе 30° — иначе выбор превращается в
 *     «угадай, какой из четырёх зелёных я брал в прошлый раз». Держится
 *     ТЕСТОМ, который считает реальный тон, а не глазами;
 *   · контраст ≥ 3:1 к БЕЛОМУ — поля на карте обводятся белым и лежат на
 *     спутниковой подложке; светлый свотч там сливается с обводкой. Тоже под
 *     тестом (считаем relative luminance по WCAG).
 *
 * Hex здесь легален: `src/lib/colorMaps/` — whitelist доменных палитр
 * (frontend-vite/CLAUDE.md). Новых hex вне этого файла быть не должно.
 */

/** 20 насыщенных — по два оттенка на тон. */
export const CATALOG_COLOR_SWATCHES: readonly string[] = [
  // красные
  '#C62828',
  // терракота
  '#E65100',
  // охра
  '#B8860B',
  // оливковые
  '#827717',
  '#6B8E23',
  // жёлто-зелёные
  '#558B2F',
  '#4C8B3F',
  // зелёные
  '#2E7D32',
  '#1B6B3A',
  // бирюзовый
  '#00897B',
  // морская волна
  '#00838F',
  // синие
  '#1E88E5',
  '#1565C0',
  // индиго
  '#3949AB',
  '#4527A0',
  // фиолетовые
  '#6A1B9A',
  '#9C27B0',
  // пурпур
  '#A31580',
  '#880E4F',
  // малиновый
  '#C2185B',
];

/** 5 нейтральных — «служебные» записи, которые не должны кричать на карте. */
export const CATALOG_NEUTRAL_SWATCHES: readonly string[] = [
  '#795548',
  '#78909C',
  '#546E7A',
  '#616161',
  '#37474F',
];

/**
 * «Нет цвета» — нейтральный серый.
 *
 * Это ОСОЗНАННЫЙ выбор человека «не хочу выделять эту запись на карте», а не
 * «пусть решит платформа» (для последнего есть отдельное действие «Вернуть
 * общий цвет», которое стирает переопределение). Совпадает с серверным
 * дефолтом заливки `COALESCE(…, '#9CA3AF')`, поэтому карточка и карта
 * показывают одно и то же.
 */
export const NO_COLOR_SWATCH = '#9CA3AF';
